import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { MasterDataService } from './shared/services/transactional/master-data/master-data';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './shared/services/interceptors/auth.interceptor';
import { errorInterceptor } from './shared/services/interceptors/http-error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),

    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAppInitializer(async () => {
      try {
        console.log('Loading master data');

        await inject(MasterDataService).load();

        console.log('Master data loaded');
      } catch (error) {
        console.error('Master data load failed', error);
      }
    }),
  ],
};
